import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { ComponentRestrictions } from 'ngx-google-places-autocomplete/objects/options/componentRestrictions';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { TimeValidatorService } from 'src/app/validators/time-validator.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { StoreService, CityService, StoreTypeService } from 'src/generated_client';


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})

export class UserManagementComponent implements OnInit {

  allStoreTypes: StoreType[] = [];
  allCities: City[] = [];
  storeId: any;
  isOpen: any;
  btnText: string = '';
  btnStyle: string = '';
  emailFormat = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}";

  public options: Options = new Options();

  shopUserForm: FormGroup = this.fb.group({
    id: [''],
    name: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    email: ['', Validators.compose([Validators.pattern(this.emailFormat), Validators.required])],
    phone: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    storeType: ['', Validators.required],
    city: ['', Validators.required],
    address: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    dsImage: [''],
    dsLogo: [''],
    image: [],
    logo: [],
    open1: ['', [Validators.required]],
    close1: ['', Validators.required],
    open2: [''],
    close2: [''],
    deliveryTime: ['', Validators.compose([Validators.required, Validators.min(1)])],
    price: ['', Validators.compose([Validators.required, Validators.min(1)])],
    tokenMP: ['',Validators.required],
    publicKeyMP:['',Validators.required],
    deliveryValue:['',Validators.required],
    maxDistance:['',Validators.required],
    additionalImg: [''],
    itemImagesUrl: this.fb.array([]),
    location: [''],
    longitude: [''],
    latitude: [''],
    slogan: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
  }, {
    validator: [this.validador.timeValidator1("open1", "close1"),
    this.validador.timeValidator2("open2", "close2")]
  })

  constructor(
    private storeService: StoreService,
    private authService: AuthService,
    private cityService: CityService,
    private storeTypeService: StoreTypeService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private snackBar: SnackBarService,
    private validador: TimeValidatorService,
  )
  {
    this.options.componentRestrictions = new ComponentRestrictions();
    this.options.componentRestrictions.country = "AR";
  }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    let store = this.authService.currentUserStore();
    this.storeId = Number(store.cdStore);
    this.storeService.apiStoreGetOneStoreGet(this.storeId).subscribe(response => {
      this.isOpen = response.isOpen;
      this.shopUserForm.controls['id'].setValue(this.storeId);
      this.shopUserForm.controls['name'].setValue(response.dsName);
      this.shopUserForm.controls['email'].setValue(response.dsEmail);
      this.shopUserForm.controls['phone'].setValue(response.dsPhone);
      this.shopUserForm.controls['storeType'].setValue(response.cdStoreType);
      this.shopUserForm.controls['city'].setValue(response.cdCity);
      this.shopUserForm.controls['address'].setValue(response.dsAddress);
      this.shopUserForm.controls['dsImage'].setValue(response.dsImg);
      this.shopUserForm.controls['dsLogo'].setValue(response.dsLogo);
      this.shopUserForm.controls['open1'].setValue(this.datePipe.transform(response.dtOpeningTime, 'shortTime'));
      this.shopUserForm.controls['close1'].setValue(this.datePipe.transform(response.dtClosingTime, 'shortTime'));
      this.shopUserForm.controls['open2'].setValue(this.datePipe.transform(response.dtOpeningTime2, 'shortTime'));
      this.shopUserForm.controls['close2'].setValue(this.datePipe.transform(response.dtClosingTime2, 'shortTime'));
      this.shopUserForm.controls['deliveryTime'].setValue(response.nmDeliveryTime);
      this.shopUserForm.controls['price'].setValue(response.qtPersonCost);
      this.shopUserForm.controls['tokenMP'].setValue(response.dsApiMeli);
      this.shopUserForm.controls['publicKeyMP'].setValue(response.dsMeliPublicKey);
      this.shopUserForm.controls['deliveryValue'].setValue(response.qtDeliveryValue);
      this.shopUserForm.controls['maxDistance'].setValue(response.nmMaximumKmDelivery);
      this.shopUserForm.controls['longitude'].setValue(response.qtLongitude);
      this.shopUserForm.controls['latitude'].setValue(response.qtLatitude);
      this.shopUserForm.controls['slogan'].setValue(response.dsSlogan);

      response.storeImages?.forEach(x => {
        this.itemImagesUrl.push(new FormControl(x))
      })
    });

    this.cityService.apiCityGetAllCitiesGet().subscribe(c => {
      c.forEach(x => {
        let city: City;
        city = {
          id: Number(x.cdCity),
          name: String(x.dsName)
        };
        this.allCities.push(city);
      });
    });

    this.storeTypeService.apiStoreTypeGetGet().subscribe(s => {
      s.forEach(x => {
        let storeType: StoreType;
        storeType = {
          id: Number(x.cdStoreType),
          name: String(x.dsName)
        };
        this.allStoreTypes.push(storeType);
      });
    });
    this.shopUserForm.markAllAsTouched();
  }

  closeShop(status: boolean) {
    this.storeService.apiStoreOpenOrCloseStorePut(this.storeId, !status).subscribe(response => {

      this.isOpen = !status;
    },
      error => {
        this.snackBar.openSnackBar('Ocurrió un error y el comercio no pudo cerrarse.', 'Aceptar')
      })
  }

  get itemImagesUrl() {
    return this.shopUserForm.get("itemImagesUrl") as FormArray
  }

  get imagesUrl() {
    return this.itemImagesUrl.value
  }

  get ImageFlex(): number {
    return 100 / this.itemImagesUrl.length;
  }

  public handleAddressChange(address: Address) {
    this.shopUserForm.controls['longitude'].setValue(address.geometry.location.lng());
    this.shopUserForm.controls['latitude'].setValue(address.geometry.location.lat());
  }

  public saveChanges(form: any) {

    let image: File = form.image?._files[0] ?? undefined;
    let logo: File = form.logo?._files[0] ?? undefined;

    let open2 = form.open2 ?? undefined;
    let close2 = form.close2 ?? undefined;

    open2 = open2 === '' ? undefined : open2;
    close2 = close2 === '' ? undefined : close2;

    if (close2 && !open2) {
      this.shopUserForm.controls['close2'].setErrors({ openWithoutValue: true });
      return;
    }

    this.storeService.apiStoreEditStorePutForm(
      form.id,
      form.city,
      form.storeType,
      form.name,
      form.email,
      form.phone,
      form.address,
      undefined,
      undefined,
      image,
      undefined,
      form.open1,
      form.close1,
      open2,
      close2,
      form.deliveryTime,
      form.price,
      form.latitude,
      form.longitude,
      undefined,
      undefined,
      logo,
      form.slogan,
      form.additionalImg,
      undefined,
      form.tokenMP,
      form.publicKeyMP,
      form.deliveryValue,
      form.maxDistance)
      .subscribe(response => {
        this.router.navigate(['user-management']);
        this.snackBar.openSnackBar('Los cambios fueron guardados con éxito.', 'Aceptar');
      },
        error => {
          console.log(error);
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar');
        });
  }

  get DsImage() {
    return this.shopUserForm.controls['dsImage'].value;
  }

  get DsLogo() {
    return this.shopUserForm.controls['dsLogo'].value;
  }
}


interface StoreType {
  id: number;
  name: string;
}
interface City {
  id: number;
  name: string;
}
